export const REVALIDATION_TIME = 60; // 1 minute

// Site branding
export const SITE_NAME = "tZERO";
export const SITE_NAME_WITH_DOMAIN = "tZERO.com";
export const DEFAULT_BASE_URL = "https://tzero.com";
export const DEFAULT_SITE_DESCRIPTION =
  "Democratizing markets through innovative capital formation and trading solutions.";
export const DEFAULT_TITLE_TEMPLATE = "%s - tZERO.com";

// Sanity CDN
export const SANITY_CDN_HOSTNAME = "cdn.sanity.io";
export const SANITY_CDN_BASE = `https://${SANITY_CDN_HOSTNAME}`;
